// CSV Export Utilities

export const exportToCSV = (data, filename) => {
  if (!data || data.length === 0) {
    alert("No data to export");
    return;
  }

  const csv = convertToCSV(data);
  downloadCSV(csv, filename);
};

const convertToCSV = (data) => {
  const headers = Object.keys(data[0]);
  const csvRows = [];

  // Add header row
  csvRows.push(headers.join(","));

  // Add data rows
  for (const row of data) {
    const values = headers.map((header) => {
      const value = row[header];
      // Escape quotes and wrap in quotes if contains comma or quote
      const escaped = ("" + value).replace(/"/g, '""');
      return /[",\n]/.test(escaped) ? `"${escaped}"` : escaped;
    });
    csvRows.push(values.join(","));
  }

  return csvRows.join("\n");
};

const downloadCSV = (csv, filename) => {
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);

  link.setAttribute("href", url);
  link.setAttribute("download", filename);
  link.style.visibility = "hidden";

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const prepareInvoicesForExport = (invoices) => {
  return invoices.map((inv) => ({
    ID: inv.id,
    "PO Number": inv.po_number || "",
    Company: inv.company_info?.name || "",
    "Amount Due": inv.amount_due || 0,
    Status: inv.status || "",
    "Client Name": inv.client_name || "",
    "Campaign Name": inv.campaign_name || "",
    "Created Date": inv.created_at
      ? new Date(inv.created_at).toLocaleDateString()
      : "",
    "Due Date": inv.due_date ? new Date(inv.due_date).toLocaleDateString() : "",
    "Payment Date": inv.payment_date
      ? new Date(inv.payment_date).toLocaleDateString()
      : "",
    Notes: inv.notes || "",
  }));
};

export const prepareCollabsForExport = (collabs) => {
  return collabs.map((collab) => ({
    ID: collab.id,
    Type: collab.type, // 'Campaign' or 'Partnership'
    Name: collab.name || "",
    Status: collab.status || collab.campaign_status || "",
    Amount: collab.amount || collab.campaign_sum || collab.computed_total || 0,
    Creator:
      collab.type === "Partnership"
        ? collab.creator || ""
        : collab.creators?.length || 0,
    "Video Amount": collab.video_amount || "",
    "Deliverables Count": collab.deliverables_count || "",
    "Created Date": collab.proposal_date
      ? new Date(collab.proposal_date).toLocaleDateString()
      : collab.created_at
      ? new Date(collab.created_at).toLocaleDateString()
      : "",
    "Launch Date": collab.launch_date
      ? new Date(collab.launch_date).toLocaleDateString()
      : "",
    Description: collab.description || "",
  }));
};

export const prepareCampaignsForExport = (campaigns) => {
  return campaigns.map((camp) => ({
    ID: camp.id,
    Name: camp.name || "",
    Status: camp.campaign_status || "",
    Amount: camp.campaign_sum || 0,
    "Video Amount": camp.video_amount || 0,
    "Creators Count": camp.creators?.length || 0,
    "Proposal Date": camp.proposal_date
      ? new Date(camp.proposal_date).toLocaleDateString()
      : "",
    "Launch Date": camp.launch_date
      ? new Date(camp.launch_date).toLocaleDateString()
      : "",
    Description: camp.description || "",
  }));
};

export const preparePartnershipsForExport = (partnerships) => {
  return partnerships.map((part) => ({
    ID: part.id,
    Name: part.name || "",
    Creator: part.creator || "",
    Status: part.status || "",
    Amount: part.computed_total || 0,
    "Deliverables Count": part.deliverables_count || 0,
    "Proposal Date": part.proposal_date
      ? new Date(part.proposal_date).toLocaleDateString()
      : "",
    Description: part.description || "",
  }));
};

export const prepareDeliverablesForExport = (deliverables) => {
  return deliverables.map((del) => ({
    ID: del.id,
    Type: del.deliverable_type || "",
    "Partnership ID": del.partnership_id || "",
    "Partnership Name": del.partnership?.name || "",
    "Creator ID": del.creator_id || "",
    Amount: del.amount || 0,
    Status: del.status || "",
    "Due Date": del.due_date
      ? new Date(del.due_date).toLocaleDateString()
      : "",
    "Created Date": del.created_at
      ? new Date(del.created_at).toLocaleDateString()
      : "",
    Notes: del.notes || "",
  }));
};